import { render, staticRenderFns } from "./PaymentCompleted.vue?vue&type=template&id=df6a3b8a&"
import script from "./PaymentCompleted.vue?vue&type=script&lang=js&"
export * from "./PaymentCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports